/* eslint-disable react/prop-types */
/* eslint-disable max-lines */
import React, { Component } from 'react';
import Nestable from './Nestable/index.js';
import { QueryBuilderContext } from './QueryBuilderContext/QueryBuilderContext.js';
import { QB_DRAG_TYPES, QB_ADD_FILTER_METHOD_TYPES, QB_GROUP_FILTER_METHOD_TYPES } from './helpers/types.js';
import QueryBuilderStore from './helpers/store.js';
import AndOrController from './AndOrController/AndOrController.js';
import QueryBuilderItem from './QueryBuilderItem/QueryBuilderItem.js';
import DisplayOutput from './DisplayOutput/DisplayOutput.js';

class QueryBuilderImpl extends Component {
  isDraggableItem = true;

  constructor(props) {
    super(props);

    this.store = new QueryBuilderStore(props.init, props.format);
    this.state = this.store.getInitialState();
  }

  onOrderDragAndDrop = (items, item) => {
    const newFilters = this.store.onOrderDragAndDrop(items, item);
    this.sendCall('reOrderOnDragAndDrop', { items });
    this.sendChange(newFilters);
  };

  onAddFilterToGroup = (idGroup) => {
    const newFilters = this.store.addFilter(idGroup);
    this.sendCall('onAddFilterToGroup', { idGroup });
    this.sendChange(newFilters);
  };

  onAddFilter = (idGroup, idFilter) => {
    const { addFilterMethod } = this.props;
    const newFilters =
      addFilterMethod === QB_ADD_FILTER_METHOD_TYPES.IN_PLACE
        ? this.store.addFilterNextToFilterId(idGroup, idFilter)
        : this.onAddFilterToGroup(idGroup);
    this.sendCall('onAddFilter', { idGroup, idFilter });
    this.sendChange(newFilters);
  };

  onAddRuleContainer = (idGroup, idFilter) => {
    const { groupFilterMethod } = this.props;
    const newFilters =
      groupFilterMethod === QB_GROUP_FILTER_METHOD_TYPES.IN_PLACE
        ? this.store.addRuleContainerInPlace(idGroup, idFilter)
        : this.store.addRuleContainer(idGroup, idFilter);
    this.sendCall('onAddRuleContainer', { idGroup, idFilter });
    this.sendChange(newFilters);
  };

  onRemoveFilter = (idFilter) => {
    const newFilters = this.store.onRemoveFilter(idFilter);
    this.sendCall('onRemoveFilter', { idFilter });
    this.sendChange(newFilters);
  };

  static getDerivedStateFromProps(props, state) {
    if (
      props.init &&
      props.init.step !== undefined &&
      Number.isInteger(props.init.step) &&
      props.init.step !== state.step
    ) {
      const store = new QueryBuilderStore(props.init, props.format);
      QueryBuilderImpl.recalculateStore = store;
      return store.getInitialState();
    }
    return null;
  }

  componentDidUpdate() {
    if (QueryBuilderImpl.recalculateStore) {
      this.store = QueryBuilderImpl.recalculateStore;
      QueryBuilderImpl.recalculateStore = null;
    }
  }

  handleFieldChange = (data) => {
    const { fieldsSharedActions } = this.props;
    const newFilters = this.store.changeFilter({
      ...data,
      fieldsSharedActions,
    });
    this.sendCall('handleFieldChange', { data });
    this.sendChange(newFilters);
  };

  handleRuleContainerOperator = (idGroup, value) => {
    const newFilters = this.store.changeGroupOperator(idGroup, value);
    this.sendCall('handleRuleContainerOperator', { idGroup, value });
    this.sendChange(newFilters);
  };

  handleRuleContainerUnGroup = (idGroup) => {
    const newFilters = this.store.unGroup(idGroup);
    this.sendCall('handleRuleContainerUnGroup', { idGroup });
    this.sendChange(newFilters);
  };

  /**
   * handleFieldChange and handleDropFilter
   * are equals right now, but they maybe
   * will have diferents logic
   * @param filter
   * @param dragTo
   */
  handleDropFilter = (filter, dragTo) => {
    const { position: oldPosition, idGroup, idFilter } = filter;
    const { position: newPosition, targetIdGroup } = dragTo;
    const newFilters = this.store.reOrderFilter(idFilter, idGroup, oldPosition, newPosition, targetIdGroup);
    this.sendCall('handleDropFilter', { filter, dragTo });
    this.sendChange(newFilters);
  };

  /**
   * handleFieldChange and handleDropFilter
   * are equals right now, but they maybe
   * will have diferents logic
   * @param group
   * @param dragTo
   */
  handleDropGroup = (group, dragTo) => {
    const { position: oldPosition, idFilter, idGroup } = group;
    const { position: newPosition, targetIdGroup } = dragTo;
    const newFilters = this.store.reOrderFilter(idFilter, idGroup, oldPosition, newPosition, targetIdGroup);
    this.sendCall('handleDropGroup', { group, dragTo });
    this.sendChange(newFilters);
  };

  handleDrop = (dragElement, dragTo) => {
    const { type } = dragElement;
    if (type === QB_DRAG_TYPES.FILTER) return this.handleDropFilter(dragElement, dragTo);
    return this.handleDropGroup(dragElement, dragTo);
  };

  sendChange = ({ format, ...newFilters }) => {
    this.setState({ format, ...newFilters });
    const { onChange } = this.props;
    onChange(format, newFilters);
  };

  sendCall = (action, data) => {
    const { [action]: callback } = this.props;
    if (callback) callback(data);
  };

  setDraggableItems = (drag) => {
    this.isDraggableItem = true;
    try {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      // eslint-disable-next-line no-useless-escape
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        const { isDraggableItem } = this.state;
        if (drag !== isDraggableItem) {
          this.setState({ isDraggableItem: drag });
        }
        this.isDraggableItem = drag;
      }
    } catch (error) {
      this.isDraggableItem = true;
    }
  };

  render() {
    const { mapGroups, main, mapFilters, step, items, format } = this.state;
    const {
      containerProps,
      ruleContainerClassName,
      fields,
      displayFixedOutput,
      displayOutput,
      displayOutputLabel,
      singleRow,
      toolTipZIndex,
    } = this.props;
    // const { children } = items[0]
    const { condition } = mapGroups[main];

    return (
      <QueryBuilderContext.Provider
        value={{
          toolTipZIndex,
          fields,
          handleDrop: this.handleDrop,
          handleFieldChange: this.handleFieldChange,
          handleRuleContainerOperator: this.handleRuleContainerOperator,
          handleRuleContainerUnGroup: this.handleRuleContainerUnGroup,
          mapFilters,
          mapGroups,
          onAddFilter: this.onAddFilter,
          onAddFilterToGroup: this.onAddFilterToGroup,
          onAddRuleContainer: this.onAddRuleContainer,
          onRemoveFilter: this.onRemoveFilter,
          ruleContainerClassName,
          showDragController: false,
          format,
          step,
          items,
          isDraggableItem: this.isDraggableItem,
          setDraggableItems: this.setDraggableItems,
          singleRow,
        }}
      >
        <div
          {...containerProps}
          className={`nested-main-group ${condition !== true ? 'is-or-group' : 'is-and-groupL'} ${
            singleRow ? 'query-main-single-row' : 'query-main-multiple-row'
          }`}
        >
          <Nestable
            isAndItem={condition === true}
            isDraggableItem={this.isDraggableItem}
            isOrItem={condition !== true}
            items={items}
            onChange={this.onOrderDragAndDrop}
            renderItem={QueryBuilderItem}
            setDraggableItems={this.setDraggableItems}
            step={step}
            singleRow={singleRow}
          />
          {!singleRow && (
            <div className="rule-container-options">
              <AndOrController
                allowUnGroup={false}
                condition={condition}
                handleRuleContainerOperator={(value) => this.handleRuleContainerOperator(main, value)}
                handleRuleContainerUnGroup={() => this.handleRuleContainerUnGroup(main)}
                isMain
                onAddFilter={() => this.onAddFilterToGroup(main)}
                showDragController={false}
                step={step}
                toolTipZIndex={toolTipZIndex}
              />
            </div>
          )}
        </div>
        {(displayOutput || displayFixedOutput) && (
          <DisplayOutput
            displayFixedOutput={displayFixedOutput}
            hideLabel={displayOutputLabel.hide}
            showLabel={displayOutputLabel.show}
            show={displayOutputLabel.open}
          />
        )}
      </QueryBuilderContext.Provider>
    );
  }
}

export default QueryBuilderImpl;
